import React, { Component } from 'react';
import imagesLoaded from 'imagesloaded';

const jquery = window.$;
const SVGLoader = window.SVGLoader;
const mina = window.mina;

export default function Preloader(WrappedComponent) {
  return class extends Component {
    constructor(props) {
      super(props);
      this.loader = null;
      this.page = null;
    }

    componentDidMount() {
      // animated scroll reveal
      const sr = window.ScrollReveal({ reset: false, duration: 1000, delay: 400 });
      sr.reveal(document.querySelectorAll('.anim_piece'));

      // preloading stuff
      this.page = jquery('#page-container');
      this.loader = new SVGLoader( document.getElementById('loader'), { speedIn : 600, easingIn : mina.easeinout } );
      window.scrollTo(0,0); // force scroll to top

      imagesLoaded(this.page, () => {
        setTimeout(() => {
          jquery('.loader').removeClass('show');
          this.loader.hide();
          this.page.addClass('show');
        }, 1000);
      });
    }

    componentWillUnmount() {
      this.loader.show();
      setTimeout(() => {
        jquery('.loader').addClass('show');
        this.page.removeClass('show');
      }, 700);
    }

    render() {
      return <WrappedComponent {...this.props} />
    }
  }
}
